export const PAGES_WITHOUT_HEADER = [
  '/auth',
  '/auth/login',
  '/auth/register',
  '/auth/verify',
  '/auth/lender-registration',
  '/contracts/view-contract',
  '/contracts/view-template',
  '/contracts/terms-and-conditions',
  '/invoicing/invoice-management',
  '/invoicing/schedule-of-values/details',
  '/contractors/view-contractor/',
  '/certificates-of-insurance/certificates-page/certificates/',
  '/certificates-of-insurance/endorsements/',
  '/lender-portal/invoice/',
  '/subcontractor-insurance/coi-manager',
  '/early-pay-calculator',
  '/early-pay-roi-calculator',
  '/full-page-promo-banner',
  '/projects/details/',
  '/early-pay/epp-ready',
  '/early-pay/create-request',
  '/early-pay/transfers',
  '/diversity-tracking/reports/',
  '/subscription',
];
